import React, { useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from '../../../../common';
import BundleProductItem from '../../PromotionTemplate/BundleProductItem';
import { isCartABOMemberType, isCartABOType } from '../../../../services/promotion/utils.service';

export const ABO_MEMBER = 'ABO';
export const FOA_MEMBER = 'RETAIL';

export const PromotionSearchScroller = ({
  items = [],
  loading,
  itemComponent: ItemComponent,
  cartData = null,
  fetchData,
  itemProps = {},
  shouldFetchData = true,
  loaderComponent: LoaderComponent = Loader,
}) => {

  const customer = useSelector(state => state.customer);

  const handleScroll = useCallback(() => {
    if (!loading && shouldFetchData) {
      const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        fetchData();
      }
    }
  }, [loading, shouldFetchData, fetchData]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return (
    <>
      {items.length > 0 ? (
        items.map((item, index) => {

          const img = item.galleryImages?.length > 0 ? item.galleryImages[0]?.image_url : '';
          let aboPrice = item.prices.find((value) => value.type === ABO_MEMBER);
          let foaPrice = item.prices.find((value) => value.type === FOA_MEMBER);
          foaPrice = +foaPrice?.price;
          aboPrice = +aboPrice?.price;
          const { accountType = '' } = cartData?.account ? cartData?.account : {};
          const isABOMemberType = isCartABOMemberType(accountType);
          const isABOType = isCartABOType(accountType);
          const isBundletItem = item.kitEntries?.length > 0;
          const price = isABOMemberType ? aboPrice : foaPrice;

          if (isBundletItem) {
            return (
              <BundleProductItem
                key={`${item.id}-${index}`}
                img={img}
                id={item.id}
                price={price}
                code={item.id}
                stock={item.stock}
                title={item.identifier}
                quantity={item.quantity}
                amwayValue={isABOType ? item.amwayValue : null}
                kitEntries={item.kitEntries}
                {...itemProps}
              />
            );
          }

          return (
            <ItemComponent
              key={`${item.id}-${index}`}
              img={img}
              id={item.id}
              price={price}
              total={item.quantity}
              code={item.id}
              stock={item.stock}
              title={item.identifier}
              amwayValue={item.amwayValue}
              {...itemProps}
            />
          );
        })
      ) : loading ? (
        <LoaderComponent />
      ) : null}

      {loading && <LoaderComponent />}
    </>
  );
};
